import { Box, Card, CardContent, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { adminApi } from '../../api/adminApi';
import { PageHeader } from '../../components/PageHeader';

export const TemplatesPage = () => {
  const { data: templates = [], isLoading } = useQuery({
    queryKey: ['admin', 'templates'],
    queryFn: adminApi.listTemplates,
  });

  return (
    <>
      <Helmet>
        <title>Šablony | Admin</title>
      </Helmet>
      <PageHeader title="Šablony soutěží" subtitle="Předpřipravené struktury kategorií a disciplín" />
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Stack spacing={2}>
          {templates.map((t) => (
            <Card key={t.id}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="h6">{t.name}</Typography>
                      {t.isSystem && <Chip size="small" label="systémová" />}
                    </Stack>
                    {t.description && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {t.description}
                      </Typography>
                    )}
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      )}
    </>
  );
};
